import IdeRunner from "../../lms-shared/IdeRunnerWarrper/IdeRunner"
import { postsApi } from '../../../utils'
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import classes from './ProjectViewerPublic.module.css'
import Header from "../../Header/Header";
import { applicationActions } from "../../../store/application-slice";
import { PermmisionPostsTypeEnumText } from "../../lms-shared/models/PermmisionPostsTypeEnum";

const ProjectViewerPublic = () => {
    const dispatch = useDispatch();
    const { applictionName, postId } = useParams();
    const [projectData, setProjectData] = useState()
    const baseDispatch = useDispatch()
    const { texts, lang } = useSelector(state => state.translate);
    const uiData = useSelector((state) => state.general.uiData);

    useEffect(() => {
        if (uiData)
            dispatch(applicationActions.setInitial({ applictionName, uiData }))
    }, [dispatch, uiData])

    useEffect(() => {
        if (lang) {
            postsApi.postsFilterPublicIdPost(postId, (error, resdata, response) => {
                if (error) {
                    baseDispatch(throwApiError({ userMessage: texts.projectsFilterIdError, error: error, statusCode: response?.statusCode, message: "projectsFilterPost " + error.message, level: 2, component: "Project", line: 58 }))
                } else {
                    if (resdata) {
                        if (resdata.shares[0].permissionMask === PermmisionPostsTypeEnumText.RunnerAndCode) {
                            let ide = JSON.parse(resdata.contentData)
                            setProjectData({
                                assessmentName: resdata.name,
                                ideUrl: ide.Ide.Url,
                                ideId: ide.Ide.Id,
                                ideLang: ide.Ide.Lang ? ide.Ide.Lang : lang,
                                ideConfig: JSON.parse(ide.Ide.AdditionalConfiguration),
                                fileUrl: resdata.url,
                                share: false,
                                author: `${resdata.user?.firstName} ${resdata.user?.lastName}`,
                            })
                        }
                        else
                        baseDispatch(throwApiError({ userMessage: texts.noPermissionTitle, error: texts.noPermissionTitle, statusCode:null, message: "projectsFilterPost " , level: 2, component: "Project", line: 58 }))
                    }
                }
            })
        }
    }, [lang])

    return (
        <div>
            <Header>
                <div className={classes.Container}>
                    <div className={classes.Text}>{texts.author} {projectData?.author}</div>
                    <div className={classes.AssessmentImg}></div>
                    <div className={classes.Text}>
                        <div className={classes.InnerText}>{projectData?.assessmentName}</div>
                    </div>
                </div>
            </Header>
            <div className={classes.IdeRunnerWarrper}>
                {projectData && <IdeRunner projectData={projectData}> </IdeRunner>}
            </div>
        </div>
    )
}
export default ProjectViewerPublic